import { arrayOf, object, string } from 'prop-types'
import RichContent from '../rich-content'

const DynamicAreas = ({ areas, container }) => {
	const dynamicArea = areas?.filter((area) => area.layout.display.container === container)

	return dynamicArea?.map((area) => (area.content ? <RichContent key={area.id} content={area.content} /> : null))
}

DynamicAreas.propTypes = {
	areas: arrayOf(object).isRequired,
	container: string.isRequired,
}

export default DynamicAreas
